






















import { Vue, Component, Prop } from 'vue-property-decorator'
import { FeedbackFormElement, ElementDate } from '@/types/Feedback.type'
import FormDatepicker from '@/components/reusable-components/form/FormDatepicker.vue'

@Component({
    components: {
        FormDatepicker,
    },
})
export default class FormPart extends Vue {
    @Prop({ required: true }) formEl!: FeedbackFormElement

    onInput(dateStr: string) {
        this.$emit('input', dateStr)
    }

    get options() {
        if ((this.formEl as ElementDate).options?.range === 'future') {
            return {
                minDate: new Date().setHours(0, 0, 0),
            }
        }

        if ((this.formEl as ElementDate).options?.range === 'past') {
            return {
                maxDate: new Date().setHours(0, 0, 0),
            }
        }

        return {}
    }
}
